module.exports = __WEBPACK_EXTERNAL_MODULE__babylonjs_core_Maths_math_vector__;